<ng-container *ngIf="visible">

  <mat-progress-bar color="accent"
                    [bufferValue]="bufferValue"
                    [mode]="mode"
                    [value]="value"></mat-progress-bar>

</ng-container>
